import { AxiosResponse } from "axios";
import { BaseResponseMapper } from "./BaseMapper";
import { DeviceManager } from "@/domain/entities/DeviceManager";

export class DeviceManagerMapper extends BaseResponseMapper {
  public convertListDeviceManagerFromApi(result: AxiosResponse): DeviceManager[] {
    const {
      data: { data },
    } = result

    return data.map(
      (device: any) => new DeviceManager(
        device.id,
        device.device_name,
        device.device_os,
        device.device_id,
        device.last_login_at,
        device.is_login
      )
    ) 
  }
}